<template>
  <b-modal
    :id="`modal-select-template-page${custom_id}`"
    modal-class="modal-select-template-page"
    size="auto-custom"
    no-close-on-esc
    no-close-on-backdrop
    hide-footer
    @shown="init()"
  >
    <template #modal-header>
      <div class="w-100">
        <div class="d-flex justify-content-between align-items-center">
          <div class="modal-title">
            <span class="backIcon cursor-pointer mr-10" @click="close()">
              <i class="fal fa-arrow-left fs-16"></i>
            </span>
            <TitleModal
              :label="
                $t(
                  'engine.commonPage.pageType.template.lblHeadV2',
                  languageEngine
                )
              "
            />
          </div>
          <div
            id="close-modal-select-template-page"
            type="button"
            class="close-modal"
            aria-label="Close"
            @click="close"
          >
            <i class="fal fa-times"></i>
          </div>
        </div>
      </div>
    </template>

    <div class="wrapper">
      <div class="list">
        <div class="list-preset">
          <div class="btn-add-preset-page">
            <b-button
              class="fs-sa-14"
              variant="default"
              @click="setActiveTabBlank()"
            >
              <i class="fas fa-plus"></i>
              {{ $t("engine.commonPage.pageType.template.btnBlankPage", languageEngine) }}
            </b-button>
          </div>
          <div
            class="group fs-dbb-20 py-gd-half px-gd-1"
            style="color: var(--font-color)"
          >
            {{ $t("engine.commonPage.pageGroupType.custom", languageEngine) }}
          </div>
          <template v-for="(tab, index) in sidetabs.custom">
            <div
              :key="`tab${index}`"
              class="fs-sa-14 p-gd-1 tilte"
              :class="[activeTabs == tab.type ? 'active' : '']"
              @click="setActiveTab(tab)"
            >
              <!-- @click="tab.type != 'blank' ? setActiveTab(tab) : setActiveTabBlank() ; templateID = '';" -->
              <div style="pointer-events: none">
                {{ tab.title }}
              </div>
            </div>
          </template>
        </div>
        <div class="list-preset list-preset-system">
          <div
            class="group fs-dbb-20 py-gd-half px-gd-1"
            style="color: var(--font-color)"
          >
            {{ $t("engine.commonPage.pageGroupType.system", languageEngine) }}
          </div>
          <template v-for="(tab, index) in sidetabs.system">
            <div
              :id="`tabs-${tab.type}`"
              :key="`tab${index}`"
              class="fs-sa-14 p-gd-1 tilte"
              :class="[activeTabs == tab.type ? 'active' : '']"
              @click="
                setActiveTab(tab);
                templateID = '';
              "
            >
              {{ tab.title }}
              <!-- <b-tooltip v-if="systemUsed.includes(tab.type)" :target="`tabs-${tab.type}`" noninteractive> {{ $t('engine.managePage.pageManage.lblPageUsed', languageEngine) }}</b-tooltip> -->
            </div>
            <!-- <div 
                :id='`tabs-${tab.type}`'
                :key="`tab${index}`" 
                class="fs-sa-14 p-gd-1 tilte" 
                :class="[activeTabs == tab.type ? 'active' : '' , systemUsed.includes(tab.type) ? 'text-muted not-allowed' : '']"
                @click="systemUsed.includes(tab.type) ? false : setActiveTab(tab);templateID = '';"
              > 
                {{ tab.title }}
                <b-tooltip v-if="systemUsed.includes(tab.type)" :target="`tabs-${tab.type}`" noninteractive> {{ $t('engine.managePage.pageManage.lblPageUsed', languageEngine) }}</b-tooltip>
              </div> -->
          </template>
        </div>
      </div>
      <div class="preview-warpper">
        <div class="preview">
          <component
            v-if="presetActive"
            :is="activeSelectPreset"
            :activeTabs="activeTabs"
            :templateID="templateID"
            :activeTypeTabs="activeTypeTabs"
            :systemUsed="systemUsed"
            :pagesUsed="pagesUsed"
            @setID="setID"
            @selected="loadData"
          />
          <div class="no-item" v-else>
            <b-overlay :show="!presetActive" rounded="sm"> </b-overlay>
          </div>
        </div>
      </div>
    </div>
    <!-- <template #modal-footer>
        <b-button variant="blue" :disabled="!templateID" @click="loadData()">
          
          {{ $t('engine.commonPage.pageType.template.lblNext', languageEngine) }}
        </b-button>
      </template> -->
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import TitleModal from "@components_system/Shared/Elements/Texts/TitleModal";
import pageService from "@services/pageService.js";

const components = {
  Default: () =>
    import(/* webpackChunkName: "SidebarDefault" */ "./Type/Default/Default"),
  System: () =>
    import(/* webpackChunkName: "SidebarSystem" */ "./Type/System/System"),
};

export default {
  data() {
    return {
      activeTabs: "",
      activeTypeTabs: "",
      activeSelectPreset: "",
      hoverTabs: "",
      templateID: "",
      pagesUsedFetching: false,
      pagesUsed: {
        system: [],
        item: [],
      },
      pagesUsedTypes: {
        system: [
          "contact",
          "online_payment",
          "inform_payment",
          "terms_condition",
          "product_brand",
          "order_tracking",
          "event_calendar",
          "policy"
        ],
        item: [
          "content_list",
          "content_item",
          "album_list",
          "album_item",
          "form_item",
          "quotation_form_item",
          "product_list",
          "product_item",
          "faq",
          "giftcard_list",
        ],
      },
      sidetabsDefault: {
        
      },
    };
  },
  components: {
    TitleModal,
    ...components,
  },
  computed: {
    ...mapGetters({
      languageUse: "design/site/languageUse",
      languageEngine: "design/userPreference/languageEngine",
      presets: "design/component/presetsOther",
      permissions: "design/permissionWebsite/permissions",
      services: "design/page/services",
    }),
    presetActive() {
      return (
        this.presets["page"][this.activeTypeTabs] &&
        this.presets["page"][this.activeTypeTabs][this.activeTabs] &&
        this.presets["page"][this.activeTypeTabs][this.activeTabs].selectLayout
      );
    },

    systemUsed() {
      return this.pagesUsed.system.map((page) => page.type);
    },
    sidetabs() {
      return {
        custom: [
          {
            title: this.$t(
              "engine.commonPage.pageType.template.aboutus",
              this.languageEngine
            ),
            type: "about_us",
            group_type: "custom",
            component: "about_us",
            hideFromType: [],
          },
          {
            title: this.$t(
              "engine.commonPage.pageType.template.service",
              this.languageEngine
            ),
            type: "service",
            group_type: "custom",
            component: "service",
            hideFromType: [],
          },
          // {
          //   title: this.$t('engine.commonPage.pageType.template.blank', this.languageEngine),
          //   type: "blank",
          //   group_type: "custom",
          //   component: "blank",
          //   hideFromType: [],
          // },
        ],
        system: [
          {
            title: this.$t(
              "engine.commonPage.pageType.contentList",
              this.languageEngine
            ),
            type: "content_list",
            group_type: "system",
            component: "blog",
            hideFromType: [],
          },
          {
            title: this.$t(
              "engine.commonPage.pageType.contentItem",
              this.languageEngine
            ),
            type: "content_item",
            group_type: "system",
            component: "post",
            hideFromType: [],
          },
          {
            title: this.$t(
              "engine.commonPage.pageType.albumList",
              this.languageEngine
            ),
            type: "album_list",
            group_type: "system",
            component: "album_list",
            hideFromType: [],
          },
          {
            title: this.$t(
              "engine.commonPage.pageType.albumItem",
              this.languageEngine
            ),
            type: "album_item",
            group_type: "system",
            component: "photo_album",
            hideFromType: [],
          },
          {
            title: this.$t(
              "engine.commonPage.pageType.formItem",
              this.languageEngine
            ),
            type: "form_item",
            group_type: "system",
            component: "form",
            hideFromType: [],
          },
          {
            title: this.$t(
              "engine.commonPage.pageType.quotationFormItem",
              this.languageEngine
            ),
            type: "quotation_form_item",
            group_type: "system",
            component: "quotation_form",
            hideFromType: [],
          },
          {
            title: this.$t(
              "engine.commonPage.pageType.faqList",
              this.languageEngine
            ),
            type: "faq",
            group_type: "system",
            component: "faq",
            hideFromType: [],
          },
          {
            title: this.$t(
              "engine.commonPage.pageType.contact",
              this.languageEngine
            ),
            type: "contact",
            group_type: "system",
            component: "contact",
            hideFromType: [],
          },
          {
            title: this.$t(
              "engine.commonPage.pageType.eventCalendar",
              this.languageEngine
            ),
            type: "event_calendar",
            group_type: "system",
            component: "event_calendar",
            hideFromType: [],
            permission: "IsCalendar",
          },
          {
            title: this.$t(
              "engine.commonPage.pageType.productList",
              this.languageEngine
            ),
            type: "product_list",
            group_type: "system",
            component: "product_list",
            hideFromType: [],
          },
          {
            title: this.$t(
              "engine.commonPage.pageType.productItem",
              this.languageEngine
            ),
            type: "product_item",
            group_type: "system",
            component: "product_item",
            hideFromType: [],
          },
          {
            title: this.$t(
              "engine.commonPage.pageType.productBrandList",
              this.languageEngine
            ),
            type: "product_brand",
            group_type: "system",
            component: "product_brands",
            hideFromType: [],
          },
          {
            title: this.$t(
              "engine.commonPage.pageType.giftcard_list",
              this.languageEngine
            ),
            type: "giftcard_list",
            group_type: "system",
            component: "giftcard_list",
            hideFromType: [],
          },
          {
            title: this.$t(
              "engine.commonPage.pageType.informPayment",
              this.languageEngine
            ),
            type: "inform_payment",
            group_type: "system",
            component: "inform_payment",
            hideFromType: [],
          },
          {
            title: this.$t(
              "engine.commonPage.pageType.onlinePayment",
              this.languageEngine
            ),
            type: "online_payment",
            group_type: "system",
            component: "online_payment",
            hideFromType: [],
          },
          {
            title: this.$t(
              "engine.commonPage.pageType.orderTracking",
              this.languageEngine
            ),
            type: "order_tracking",
            group_type: "system",
            component: "order_tracking",
            hideFromType: [],
          },
          {
            title: this.$t(
              "engine.commonPage.pageType.terms",
              this.languageEngine
            ),
            type: "terms_condition",
            group_type: "system",
            component: "terms_condition",
            hideFromType: [],
          },
          {
            title: this.$t(
              "engine.commonPage.pageType.policy",
              this.languageEngine
            ),
            type: "policy",
            group_type: "system",
            component: "policy",
            hideFromType: [],
          },
        ],
      };
    },
  },
  methods: {
    init() {
      this.fetchPagesUsed();
      this.setID("");
      if (this.$route.query.action == 'add_page') {
        if (this.$route.query.type) {
          this.setActiveTab({ type: this.$route.query.type, group_type: "system" });
        }
      } else {
        this.setActiveTab({ type: "about_us", group_type: "custom" });
      }
      this.$store.dispatch("design/component/loadPreset", {
        type: "page",
        metaName: "other",
        pageType: "blank",
        groupType: "custom",
      });
    },
    setActiveTab(tab = {}) {
      // tab.component
      this.activeSelectPreset =
        tab.group_type != "system" ? "Default" : "System";
      if (tab.type != "blank") {
        const tabHover = tab.type;
        if (this.hoverTabs != tabHover) {
          this.hoverTabs = tabHover;
          if (tabHover && this.hoverTabs == tabHover) {
            if (
              tab.group_type &&
              tab.type &&
              !this.presets["page"][tab.group_type][tab.type]
            ) {
              this.$store.dispatch("design/component/loadPreset", {
                type: "page",
                metaName: "other",
                pageType: tab.type,
                groupType: tab.group_type,
              });
            }
            this.activeTabs = tabHover;
            this.activeTypeTabs = tab.group_type;
          }
        }
      }
    },
    setActiveTabBlank() {
      // this.$store.dispatch("design/component/loadPreset", {
      //   type: 'page',
      //   metaName: 'other',
      //   pageType: 'blank',
      //   groupType: 'custom',
      // });
      let blankID = "";
      let open = false;
      const timer = setInterval(() => {
        setTimeout(() => {
          this.$bvModal.hide(`modal-select-template-page${this.custom_id}`);
          blankID =
            this.presets &&
            this.presets.page.custom &&
            this.presets.page.custom.blank &&
            this.presets.page.custom.blank.selectLayout &&
            this.presets.page.custom.blank.selectLayout[0] &&
            this.presets.page.custom.blank.selectLayout[0].id;
          if (!open) {
            this.$emit("setData", {
              templateID: blankID,
              activeTabs: "blank",
              activeTypeTabs: "custom",
            });
            this.$bvModal.show(`modal-add-page${this.custom_id}`);
            open = true;
          }
        }, 100);
        if (blankID) clearInterval(timer);
      }, 1);
    },
    // Pages Used
    async fetchPagesUsed() {
      this.pagesUsedFetching = true;
      let response = await pageService.getPagesUsed({
        filterType: "language",
        language: this.languageUse,
      });
      this.pagesUsed = {
        system: Object.values(response)[1].filter((ele) =>
          this.pagesUsedTypes.system.includes(ele.type)
        ),
        item: Object.values(response)[1].filter((ele) =>
          this.pagesUsedTypes.item.includes(ele.type)
        ),
      };
      this.pagesUsedFetching = false;
    },
    setID(id) {
      this.templateID = id;
    },
    loadData() {
      this.$bvModal.hide(`modal-select-template-page${this.custom_id}`);
      this.$emit("setData", {
        templateID: this.templateID,
        activeTabs: this.activeTabs,
        activeTypeTabs: this.activeTypeTabs,
      });
      this.$bvModal.show(`modal-add-page${this.custom_id}`);
    },
    close() {
      if (this.$route.query.redirect_wb) {
        this.redirectToWb();
      } else {
        this.setID("");
        this.setActiveTab({ type: "about_us", group_type: "custom" });
        this.$bvModal.hide(`modal-select-template-page${this.custom_id}`);
        this.$bvModal.show(this.custom_open);
      }
    },
    redirectToWb() {
      window.location.href = this.services.webbuilderCmsUrl+`?${this.$route.query.redirect_wb}`;
    }
  },
  props: {
    templateDataTemp: {
      type: Object,
      default: () => {},
    },
    custom_id: {
      type: String,
      default: "",
    },
    custom_open: {
      type: String,
      default: "modal-manage-page",
    },
  },
};
</script>

<style lang="scss">
.modal-select-template-page {
  .modal-content {
    height: 100%;
    border: 1px solid #dee3e6;
  }
  .modal-body {
    padding: 0;
    height: calc(95vh - 130px);
  }
  .wrapper {
    display: grid;
    grid-template-columns: 200px auto;
    height: 100%;
    .list {
      overflow-y: scroll;
      .list-preset {
        overflow-y: scroll;
        padding: 16px;
        &:not(.list-preset-system) {
          border-bottom: 1px solid #e2e7e9;
        }
        .tilte {
          cursor: pointer;

          &.not-allowed {
            cursor: not-allowed;
            &:hover {
              background-color: #f8f9fa;
            }
          }
          &.active,
          &:hover {
            color: var(--primary);
            background-color: #f4fcff;
          }
        }
        .btn-add-preset-page {
          padding: 8px;
          margin-bottom: 7px;
          .btn {
            width: 100%;
          }
        }
      }
    }
    .preview-warpper {
      padding: 16px 24px;
      background-color: #f8f9fa;
      position: relative;
      overflow-y: scroll;
      /* border-bottom-right-radius: calc(0.3rem - 1px); */
      .mb-16 {
        margin-bottom: 16px;
      }
      .preview {
        height: 100%;
        .no-item {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
  .wrapper-system {
    overflow-y: scroll;
    overflow-x: hidden;
    background-color: #f8f9fa;
  }
  .preview-system-wrapper {
    padding: 16px 26px 0px 26px;
    position: relative;
  }
}
</style>
